import axios from 'axios';

export const FACE_WIDTH = 960;
export const FACE_HEIGHT = 1280;

export function faceCrop(width, height) {
  if (!(width > 0 && height > 0)) throw new Error('Кадр камеры ещё не готов');
  const cropWidth = Math.min(width, height * FACE_WIDTH / FACE_HEIGHT);
  const cropHeight = Math.min(height, width * FACE_HEIGHT / FACE_WIDTH);
  return { x: (width - cropWidth) / 2, y: (height - cropHeight) / 2, width: cropWidth, height: cropHeight };
}

export function captureInfinFaceFrame(video, canvas) {
  const crop = faceCrop(video.videoWidth, video.videoHeight);
  canvas.width = FACE_WIDTH;
  canvas.height = FACE_HEIGHT;
  // A lossless, explicitly sRGB intermediate. Final progressive JPEG encoding
  // and colour conversion happen once on the server, independent of browser.
  const context = canvas.getContext('2d', { alpha: false, colorSpace: 'srgb' });
  if (!context) throw new Error('Не удалось подготовить снимок камеры');
  context.fillStyle = '#fff';
  context.fillRect(0, 0, FACE_WIDTH, FACE_HEIGHT);
  context.drawImage(video, crop.x, crop.y, crop.width, crop.height, 0, 0, FACE_WIDTH, FACE_HEIGHT);
  return canvas.toDataURL('image/png');
}

export async function normalizeInfinFacePhoto(value, providerId, options = {}) {
  if (!providerId) throw new Error('Не выбран провайдер Infin');
  const response = await axios.post(`dashboard/providers/${providerId}/face-photo/normalize`, { value }, {
    timeout: 30000, ...options,
  });
  const data = response.data;
  if (!data || data.status !== true || typeof data.photoBase64 !== 'string' || !data.photoBase64.startsWith('/9j/')) {
    throw new Error((data && data.message) || 'Не удалось подготовить фото для Infin');
  }
  return data.photoBase64;
}

export function facePhotoError(error) {
  const data = error && error.response && error.response.data;
  if (data && data.errors && data.errors.value) return data.errors.value[0];
  if (data && data.message) return data.message;
  return (error && error.message) || 'Не удалось подготовить фото';
}
